<template>
  <div>
    <nprogress-container/>
    <cookie-alert></cookie-alert>
    <dev-server-modal />
    <div class="app">
      <NavbarContainer />
      <div class="app-body">
        <template v-if="isAuthenticated">
          <SidebarContainer />
        </template>
        <UpButton />
        <main class="main">
          <div class="container-fluid h-100">
            <toaster></toaster>
            <tech-support-form-modal></tech-support-form-modal>
            <router-view/>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import { mapGetters } from 'vuex'
import Toaster from '@/components/ui/Toaster.vue'
import UpButton from '@/components/ui/UpButton.vue'
import NavbarContainer from '@/components/ui/navbar/Container.vue'
import SidebarContainer from '@/components/ui/sidebar/Container.vue'
import DevServerModal from '@/components/common/modals/DevServerModal.vue'

const TechSupportFormModal = () => import('@/components/common/modals/TechSupportFormModal.vue')
const CookieAlert = () => import('@/components/common/cookies/CookieAlert.vue')

export default {
  name: 'App',
  components: {
    NprogressContainer,
    CookieAlert,
    DevServerModal,
    Toaster,
    NavbarContainer,
    SidebarContainer,
    TechSupportFormModal,
    UpButton
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'currentUser/isAuthenticated'
    })
  }
}
</script>

<style lang="scss">
  @import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
  @import "sass/app";
  .app-body {
    margin-top: 80px;
  }
  @media screen and (max-width: 991.6px) {
    .app-body {
      margin-top: 0;
    }
  }
</style>
